import asCanvasElement from '../../utils/CanvasElement';
import ButtonContainerElement from './ButtonContainerElement';
import type { ButtonContainerElementProps } from './types';

export type { ButtonContainerElementProps };
export default asCanvasElement(ButtonContainerElement);
